module.exports = __webpack_public_path__ + "img/reward.202e9f7c.png";